export default __webpack_public_path__ + "img/bg-illustration-mobile.png";